import type {AxiosProgressEvent} from "axios";
import {api} from "./index.ts";

export type UploadedFile = {
    key: string;
    url: string;
};

export async function uploadFileToApi(
    file: File,
    options: {
        folder?: string;
        onProgress?: (percent: number) => void;
    } = {}
): Promise<UploadedFile> {
    const formData = new FormData();
    formData.append("file", file);

    const response = await api.post("/files/upload", formData, {
        params: options.folder ? {folder: options.folder} : undefined,
        onUploadProgress: options.onProgress
            ? (event: AxiosProgressEvent) => {
                if (!event.total) return;
                const percent = Math.round((event.loaded * 100) / event.total);
                options.onProgress?.(percent);
            }
            : undefined,
    });

    const payload = response.data;
    const fileObj = payload?.file ?? payload;

    if (fileObj && typeof fileObj.key === "string" && typeof fileObj.url === "string") {
        return {key: fileObj.key, url: fileObj.url};
    }

    throw new Error("Unexpected upload response");
}

